import React from "react";
// import "./serviceDetail.css";
// import ServiceContactForm from "../pages/servicecontactform";
import ContactForm from "../pages/Contact";



export default function ExteriorProjects() {
  return (
    <div className="page-container">

      {/* Hero */}
      <section
        className="hero"
        style={{ backgroundImage: "url('/Gallerypics/photo-1693691738879-e999316da868.jpeg')" }}
      >
        <div className="hero-overlay"></div>
        <h1 className="hero-title">Exterior Projects</h1>
      </section>

      {/* Intro */}
      <section className="section">
        <p>
          Our exterior painting services provide durability and beauty for
          outdoor surfaces. Using weather-resistant coatings, we protect your
          property from harsh elements while enhancing curb appeal.
        </p>
      </section>

      {/* Why Choose Us */}
      <section className="section bg-light">
        <h2>Why Choose Us</h2>
        <div className="why-list">
          <div className="why-item">
            <i className="fas fa-home"></i>
            <p>Long-lasting outdoor protection</p>
          </div>
          <div className="why-item">
            <i className="fas fa-cloud-sun"></i>
            <p>Weather & UV resistant paints</p>
          </div>
          <div className="why-item">
            <i className="fas fa-leaf"></i>
            <p>Eco-friendly coating options</p>
          </div>
          <div className="why-item">
            <i className="fas fa-tools"></i>
            <p>Expert preparation & application</p>
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="section">
        <h2>Our Process</h2>
        <ol className="process-list">
          <li>Surface cleaning & repair</li>
          <li>Application of primer</li>
          <li>Multiple coats for lasting color</li>
          <li>Final sealing & inspection</li>
        </ol>
      </section>

      {/* Gallery */}
      <section className="section bg-light">
        <h2>Recent Projects</h2>
        <div className="gallery">
          <img src="/Gallerypics/photo-1693691738879-e999316da868.jpeg" alt="Exterior Project 1" />
          <img src="/Project pics/Khyaban.JPG" alt="Exterior Project 2" />
          <img src="/Project pics/Chenab Club .jpg" alt="Exterior Project 3" />
        </div>
      </section>

      {/* Contact Form */}
      <ContactForm/>
      
 

    </div>
  );
}
